var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats-list"},[_c('span',{staticClass:"stats-list-header"},[_vm._t("listHeader")],2),_c('div',{staticClass:"stats-list-row"},[_vm._t("listRows")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }